import { type AbsoluteRouteOnlyPath, getBreadcrumbConfig, isRouteParent } from '../routing'
import { useRouting } from '../routing'
import { getNavigationConfig } from './Config'

export const useNavigationRouting = useRouting.extend(
    (RoutingHook) =>
        class extends RoutingHook {
            getSideMenuGroups (pool: readonly AbsoluteRouteOnlyPath[]): [AbsoluteRouteOnlyPath[], AbsoluteRouteOnlyPath[]] {
                const currentPath = this.state.path
                const { parents } = getBreadcrumbConfig(currentPath)

                /**
                 *  Breadcrumbs are sorted from children to parent,
                 *  so we take the last parent, which is the top parent.
                 */
                const [topParent] = parents.slice(-1)
                const topParentPath = topParent ? topParent.id : currentPath

                return pool.reduce<[AbsoluteRouteOnlyPath[], AbsoluteRouteOnlyPath[]]>(
                    (prev, route) => {
                        // Check if the child route is not part of the parent route, then skip assigning the route
                        if (!isRouteParent(route, topParentPath)) {
                            return prev
                        }
                        // Check if a child route should be in the extra menu, then add it to the second list
                        if (getNavigationConfig(route, 'isExtraMenu')) {
                            prev[1].push(route)
                        } else {
                            // otherwise, add it to the main menu
                            prev[0].push(route)
                        }
                        return prev
                    },
                    [[], []]
                )
            }
        },
    'useNavigationRouting'
)
